// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeSlider_container__2NuP9","textContainer":"HomeSlider_textContainer__19piJ","genre":"HomeSlider_genre__1iWVI"};